import React from 'react';
import { ArrowDown, Play } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToPortfolio = () => {
    document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-black">
      {/* Hero Image - Right Side */}
      <div className="absolute inset-0 lg:left-1/2">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1920&h=1080&fit=crop)',
          }}
        >
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-transparent"></div>
        </div>
      </div>

      {/* Content - Left Side */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-24">
        <div className="max-w-3xl">
          {/* Small label */}
          <div className="mb-8 animate-fade-in">
            <span className="text-sm tracking-[0.3em] text-zinc-500 uppercase font-medium">
              Video Editor & Designer
            </span>
          </div>

          {/* Large Name */}
          <h1 className="mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <span className="block text-7xl md:text-9xl font-black tracking-tighter text-white mb-2">
              SLOOMX
            </span>
          </h1>

          {/* Tagline with contrast */}
          <h2 className="mb-8 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <span className="block text-4xl md:text-6xl font-black tracking-tight">
              <span className="text-white">WHERE ART</span>
            </span>
            <span className="block text-4xl md:text-6xl font-black tracking-tight text-cyan-400">
              MEETS CINEMA
            </span>
          </h2>

          {/* Description */}
          <p className="text-xl text-zinc-400 mb-12 max-w-2xl leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            5 years crafting compelling visual stories. From raw footage to cinematic experiences that captivate and inspire.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-16 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <Button 
              size="lg" 
              onClick={scrollToPortfolio}
              className="group bg-white hover:bg-zinc-100 text-black px-8 py-6 text-base font-bold transition-all duration-300 hover:scale-105"
            >
              <Play className="mr-2 h-5 w-5 fill-black" />
              VIEW WORK
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-white hover:bg-white hover:text-black text-white px-8 py-6 text-base font-bold bg-transparent transition-all duration-300 hover:scale-105"
            >
              GET IN TOUCH
            </Button>
          </div>

          {/* Scroll indicator */}
          <div className="animate-bounce" style={{ animationDelay: '0.5s' }}>
            <button 
              onClick={scrollToPortfolio}
              className="flex items-center gap-2 text-sm text-zinc-500 hover:text-white transition-colors"
            >
              <ArrowDown className="h-4 w-4" />
              <span className="tracking-wider uppercase">Scroll to explore</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
